/* tslint:disable */

declare var Object: any;
export interface AmazonS3Interface {
  "id"?: number;
}

export class AmazonS3 implements AmazonS3Interface {
  "id": number;
  constructor(data?: AmazonS3Interface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `AmazonS3`.
   */
  public static getModelName() {
    return "AmazonS3";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of AmazonS3 for dynamic purposes.
  **/
  public static factory(data: AmazonS3Interface): AmazonS3{
    return new AmazonS3(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'AmazonS3',
      plural: 'AmazonS3',
      path: 'AmazonS3',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}
